import "./hallBenefits.scss";
import { IPartnerBenefit } from "@src/api/partner/partner";

export default function HallBenefits(props: { benefits: IPartnerBenefit[] }) {
  const benefits = props.benefits.filter((benefit) => benefit.title);

  return (
    <>
      {benefits.length > 0 && (
        <div className="hall-benefits-list-wrap">
          <ul className="benefits-list">
            {benefits.map((item, idx) => (
              <BenefitItem
                key={idx}
                tag={item?.tag || "캐시백"}
                iconUrl={item.iconUrl}
                title={item.title}
                content={item.content}
              />
            ))}
          </ul>
        </div>
      )}
    </>
  );
}

function BenefitItem(props: {
  tag: string;
  iconUrl: string;
  title: string;
  content: string;
  // isLastItem?: boolean;
}) {
  const isWbDiscount = props.tag === "할인";
  return (
    <li className="benefit-item">
      <div>
        {isWbDiscount ? (
          <>
            <h3 className="benefit-title">웨딩북 단독 혜택</h3>
            <p className="benefit-content benefit-content-wb-discount">
              웨딩북을 통해 방문 시 추가 할인 혜택이 적용됩니다.
            </p>
          </>
        ) : (
          <>
            <h3 className="benefit-title">{props.title}</h3>
            <p className="benefit-content">{props.content}</p>
          </>
        )}
      </div>
    </li>
  );
}
